import { render } from "./Report10.vue?vue&type=template&id=2f78eac4"
import script from "./Report10.vue?vue&type=script&lang=js"
export * from "./Report10.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Vue_Project\\JamoatFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__